import api from './api';

export const productionService = {
  listProjects: () => api.get('/production/projects'),
  startProduction: (projectId) =>
    api.post(`/production/projects/${projectId}/start`),
  stopProduction: (projectId) =>
    api.post(`/production/projects/${projectId}/stop`),
  syncStages: (projectId) =>
    api.post(`/production/projects/${projectId}/sync-stages`),
  updateStage: (projectId, stageValue, payload) =>
    api.put(`/production/projects/${projectId}/stages/${stageValue}`, payload),
  moveToStage: (projectId, stageValue) =>
    api.post(`/production/projects/${projectId}/move`, { stage_value: stageValue }),
  addOptionalStage: (projectId, stageValue) =>
    api.post(`/production/projects/${projectId}/add-stage/${stageValue}`),
  removeOptionalStage: (projectId, stageValue) =>
    api.post(`/production/projects/${projectId}/remove-stage/${stageValue}`),
  reorderStages: (projectId, stageOrder) =>
    api.post(`/production/projects/${projectId}/reorder-stages`, { stage_order: stageOrder }),
};
